import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalView: {
    backgroundColor: 'white',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingHorizontal: 24,
    paddingTop: 12,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: -2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: '100%',
  },
  handle: {
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: Colors.GrayPallete.lightgrayTwo,
    marginBottom: 28,
  },
  title: {
    fontSize: 22,
    fontFamily: 'TCCC-UnityText Bold',
    color: '#111',
    textAlign: 'center',
    marginBottom: 32,
    paddingHorizontal: 8,
  },
  allowButton: {
    marginBottom: 8,
  },
  laterButton: {
    paddingVertical: 14,
  },
  laterText: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.BluePallete.blue,
    textAlign: 'center',
  },
});
